<div class="container">
  <mat-card class="example-card">
    <mat-card-header>
      <div
        mat-card-avatar
        class="example-header-image"
      ></div>
      <mat-card-title>DISCLAIMER</mat-card-title>
      <mat-card-subtitle>Please read carefully.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <p [innerHtml]="content"></p>
    </mat-card-content>
    <mat-card-actions>
    </mat-card-actions>
  </mat-card>
</div>
